
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/erpcige/cigeplanillas",
      function () {
        return require("private-next-pages/erpcige/cigeplanillas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/erpcige/cigeplanillas"])
      });
    }
  